import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { Market } from '../core/markets/market';
import { MarketsService } from '../core/markets/markets.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

const DefaultMarketId = 'default';

@Injectable({
  providedIn: 'root',
})
export class MarketSelectorService {
  private selectedMarketId$$: ReplaySubject<string> = new ReplaySubject<string>(1);
  public selectedMarketId$: Observable<string> = this.selectedMarketId$$
    .asObservable()
    .pipe(shareReplay({ bufferSize: 1, refCount: true }));
  public marketDropdownOptions$: Observable<Market[]>;

  constructor(private marketsService: MarketsService) {
    this.marketDropdownOptions$ = this.marketsService.getMarkets().pipe(shareReplay({ bufferSize: 1, refCount: true }));

    this.marketDropdownOptions$.pipe(takeUntilDestroyed()).subscribe((markets) => {
      let initialMarket = markets.find((market) => market.market_id === DefaultMarketId);
      if (!initialMarket) {
        initialMarket = markets[0];
      }
      this.selectedMarketId$$.next(initialMarket.market_id);
    });
  }

  public setSelectedMarketId(marketId: string): void {
    this.selectedMarketId$$.next(marketId);
  }
}
